import { create } from 'zustand';
import { fetchRegisterQr, fetchLoginQr } from './api/qr-employees-api';

interface Store {
  fetchRegisterQr: (id: string) => Promise<void>;
  fetchLoginQr: (id: string) => Promise<void>;
  registerQr?: string;
  loginQr?: string;
  isLoadingFetch?: boolean;
}

export const useQrStaffStore = create<Store>((set) => ({
  fetchRegisterQr: async (id) => {
    set({ isLoadingFetch: true });
    try {
      const resp = await fetchRegisterQr(id);
      set({ registerQr: resp });
    } catch (e) {
      console.error(e);
    } finally {
      set({ isLoadingFetch: false });
    }
  },
  fetchLoginQr: async (id) => {
    set({ isLoadingFetch: true });
    try {
      const resp = await fetchLoginQr(id);
      set({ loginQr: resp });
    } catch (e) {
      console.error(e);
    } finally {
      set({ isLoadingFetch: false });
    }
  },
}));
